import { useClient } from 'apprise-frontend-core/client/context'




export type Service = {

    prefix: string
    default?: boolean

}

const noService: Service = { prefix: ''}

export const useService = () => {


    const client = useClient()

    const self = {


        get: (name: string): Service =>  client.get().services[name] ?? self.default()

        ,

        default: () : Service => {

            const config = client.get()

            for (const k in config.services)
                if (config.services[k].default)
                    return config.services[k]


            const keys = Object.keys(config.services)

            return keys.length ? config.services[keys[0]] : noService

        }


    }

    return self
}